import { z } from 'zod';

export const OrderBy = z.enum(['ASC', 'DESC']);

export type OrderBy = z.infer<typeof OrderBy>;
